import * as Emitter from 'tiny-emitter';
const bus = new Emitter.TinyEmitter();
export default bus;
